import React from "react";
import Button from "../../../components/buttons/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAward } from "@fortawesome/free-solid-svg-icons";
import style from "./style.module.scss";
import { AdminStatusType } from "../../../services/admin.service";

interface IAdminStatus {
  status: AdminStatusType;
  adminStatusUpdate: (status: AdminStatusType) => void;
}

const AdminStatusButtons = ({ status, adminStatusUpdate }: IAdminStatus) => {
  return (
    <>
      {status === AdminStatusType.ACTIVE && (
        <div>
          <div style={{ justifyContent: "space-between", display: "flex" }}>
            <div className="dashboard-button">
              <Button
                name="Suspend"
                type="activate-button"
                onClick={() => adminStatusUpdate(AdminStatusType.SUSPENDED)}
              />
              <Button
                name="Deactivate"
                type="delete-button"
                onClick={() => adminStatusUpdate(AdminStatusType.DEACTIVATED)}
              />
            </div>
          </div>
        </div>
      )}

      {status === AdminStatusType.DEACTIVATED && (
        <>
          <div style={{ justifyContent: "space-between", display: "flex" }}>
            <div className="dashboard-button">
              <Button
                name="Activate"
                type="activate-button"
                onClick={() => adminStatusUpdate(AdminStatusType.ACTIVE)}
              />
            </div>
          </div>
        </>
      )}

      {/* Verify button */}
      {status === AdminStatusType.SUSPENDED && (
        <>
          <div style={{ justifyContent: "space-between", display: "flex" }}>
            <div className="dashboard-button">
              <Button
                name="Activate"
                type="activate-button"
                onClick={() => adminStatusUpdate(AdminStatusType.ACTIVE)}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AdminStatusButtons;
